import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    rowSpaceBetween: {
        justifyContent: "space-between",
        flexDirection: "row"
    },
    borderedCard: {
        borderRadius: 10,
        borderWidth: 1
    },
    paddedContainer: {
        width: "100%"
    }
});
export default stylesheet;
